import styled from "styled-components";

const Banner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #fef3cd;
  color: #856404;
  text-align: center;
  padding: 6px 12px;
  font-size: 13px;
  font-family: Arial, sans-serif;
`;

const messages = {
  en: "You're offline. Messages won't send.",
  fr: "Vous êtes hors ligne. L'envoi de messages est impossible.",
  es: "Estás sin conexión. No se pueden enviar mensajes.",
  sp: "Estás sin conexión. No se pueden enviar mensajes.",
};

const OfflineBanner = ({ lang }) => (
  <Banner>{messages[lang] || messages.en}</Banner>
);

export default OfflineBanner;
